import React from 'react';
import {BriefcaseIcon} from '@heroicons/react/24/solid'

const Experience = () => {
  const experienceData = [
    {
      title: "Graduate Engineer Trainee",
      company: "HCLTech",
      duration: "Oct 2024 - Present",
    },
    {
      title: "Java Developer Intern",
      company: "Hulkhire company, Hyderabad",
      duration: "May 2024 - Jul 2024",
    }
  ];

  return (
    <section id='experience' className="bg-[#8C3061] flex flex-col items-center py-20 text-white">
      <h1 className="md:text-3xl text-xl font-extrabold mb-12">Experience</h1>
      <div className="md:w-full w-[90%] max-w-2xl space-y-8">
        {experienceData.map((experience, index) => (
          <div key={index} className="relative bg-[#522258] shadow-lg rounded-lg p-6 border border-gray-200 mt-8">
            {/* Timeline Divider */}
            <div className="absolute inset-y-0 left-0 w-1 bg-[#D95F59] text-white rounded-tl-lg rounded-bl-lg"></div>

            {/* Icon */}
            <div className="flex items-center space-x-4 text-white">
              <BriefcaseIcon className="h-8 w-8 text-[#D95F59]" />
              <h2 className="md:text-2xl text-lg font-medium text-white">{experience.title}</h2>
            </div>

            {/* Company and Duration */}
            <p className="text-white mt-1">
              <span className="md:font-medium text-sm">{experience.company}</span> &mdash; <span>{experience.duration}</span>
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
